import { combineReducers } from 'redux';
import list from 'projects/reducers/projects_list_reducers';
import form from 'projects/reducers/projects_form_reducers';

export const projectsReducers = combineReducers({ list, form });



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/reducers/index.js